import axios from "axios";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles, containerSummaryDetailTableCustomStyles } from "../../utils/TableCustomStyles";
import "../../components/css/StepperForm.css";
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

function ContainerSummary() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [filters, setFilters] = useState({ location: '' });

  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const user_role = sessionStorage['userrole']
  const user_id = sessionStorage['id']
  const [loggedInUser, setLoggedInUser] = useState(null);

  const getLoggenInUser = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/user/' + user_id);
      if (response) {
        setLoggedInUser(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  }

  const getContainerSummary = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/inventory/container/containersummary/');

      setTimeout(() => {
        if (response) {
          setData(response.data)
          setDataPending(false)
        }
      }, 500);

    } catch (err) {
      toast.error("Error in fetching container data! Try again.");
    }
  }

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/role/getuserrolepermission?roles=' + roles);

      const role_permissions_array = []
      for (let i = 0; i < response.data?.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array?.length; j++) {
          if (!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])) {
            role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
          }
        }
      }

      if (role_permissions_array) {
        setCurrentUserRolePermissionData(role_permissions_array)
      }

    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  }

  useEffect(() => {
    getLoggenInUser()
    getContainerSummary()
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role)
  }, [user_role]);

  const handleFilterChange = (column, value) => {
    setFilters(prev => ({ ...prev, [column]: value }));
  };

  const filteredData = data.filter(item =>
    Object.keys(filters).every(key =>
      item[key]?.toLowerCase().includes(filters[key]?.toLowerCase())
    )
  );

  const columns = [
    {
      name: (
        <input
          className="form form-control-sm mx-0 my-1"
          placeholder="Location"
          onChange={e => handleFilterChange('location', e.target.value)}
          style={{ width: '100px'}}
        />
      ),
      width: '160px',
      selector: row => <span class={row.location=='Total'?'fw-bold text-inox-green':''}>{row.location}</span>,
      sortable: true
    },
    {
      name: 'Empty',
      center: true,
      selector: row => 
      {
        const status = row.summary?.status || {};
        return (
          <span class={row.location=='Total'?'fw-bold text-inox-green':''}>
          {(status.EMPTY_APPROVED || 0) +
          (status.EMPTY_AV || 0) +
          (status.EMPTY_ESTIMATED || 0) +
          (status.EMPTY_REPAIRED || 0) +
          (status.EMPTY_UNESTIMATED || 0)}
          </span>
        );
      }
    },
    {
      name: 'Booked',
      center: true,
      selector: row => <span class={row.location=='Total'?'fw-bold text-inox-green':''}>{row.summary?.status?.BOOKED ?? 0}</span>,
      sortable: true,
    },
    {
      name: 'Picked',
      center: true,
      selector: row => <span class={row.location=='Total'?'fw-bold text-inox-green':''}>{row.summary?.status?.PICKED ?? 0}</span>,
      sortable: true,
    },
    {
      name: 'On the way',
      center: true,
      selector: row => <span class={row.location=='Total'?'fw-bold text-inox-green':''}>{row.summary?.status?.ON_THE_WAY ?? 0}</span>,
      sortable: true,
    },
    {
      name: 'Import Laden',
      center: true,
      selector: row => <span class={row.location=='Total'?'fw-bold text-inox-green':''}>{row.summary?.status?.IMPORT_LADEN ?? 0}</span>,
      sortable: true,
    },
    {
      name: 'Exported',
      center: true,
      selector: row => <span class={row.location=='Total'?'fw-bold text-inox-green':''}>{row.summary?.status?.EXPORTED ?? 0}</span>,
      sortable: true,
    },
    {
      name: 'Leased Out',
      selector: row => <span class={row.location=='Total'?'fw-bold text-inox-green':''}>{row.summary?.status?.LEASED_OUT ?? 0}</span>,
      sortable: true,
    },
    {
      name: 'Off Hired',
      center: true,
      selector: row => <span class={row.location=='Total'?'fw-bold text-inox-green':''}>{row.summary?.status?.OFFHIRED ?? 0}</span>,
      sortable: true,
    },
    {
      name: 'Sold',
      center: true,
      selector: row => <span class={row.location=='Total'?'fw-bold text-inox-green':''}>{row.summary?.status?.SOLD_UNIT ?? 0}</span>,
      sortable: true,
    },
    {
      name: 'Unavailable',
      center: true,
      selector: row => <span class={row.location=='Total'?'fw-bold text-inox-green':''}>{row.summary?.status?.UNAVAILABLE ?? 0}</span>,
      sortable: true,
    },
    {
      name: 'None',
      center: true,
      selector: row => <span class={row.location=='Total'?'fw-bold text-inox-green':''}>{row.summary?.status?.NONE ?? 0}</span>,
      sortable: true,
    },
    {
      name: 'Total',
      center: true,
      selector: row => <span class={row.location=='Total'?'fw-bold text-inox-green':''}>{row.total ?? 0}</span>,
      sortable: true,
    }
  ];

  const ExpandedComponent = ({ data }) => {

    const summarydetailcolumns = [
      {
        name: 'Details',
        width: '160px',
        selector: row => 
          <>
            <span><b>Location:</b> {row.summary?.location}</span><br></br>
            <span><b>Agent:</b> {row.summary?.agent}</span><br></br>
            <span><b>Depot:</b> {row.depot}</span>
          </>,
        sortable: true,
      },
      {
        name: 'Empty',
        center: true,
        selector: row => 
        {
          const status = row.summary?.status || {};
          const EMPTYHD20 = (status?.EMPTY_APPROVEDHD20 || 0) + (status?.EMPTY_AVHD20 || 0) + (status?.EMPTY_ESTIMATEDHD20 || 0) + (status?.EMPTY_REPAIREDHD20 || 0) + (status?.EMPTY_UNESTIMATEDHD20 || 0);
          const EMPTYHD40 = (status?.EMPTY_APPROVEDHD40 || 0) + (status?.EMPTY_AVHD40 || 0) + (status?.EMPTY_ESTIMATEDHD40 || 0) + (status?.EMPTY_REPAIREDHD40 || 0) + (status?.EMPTY_UNESTIMATEDHD40 || 0);
          const EMPTYHQ40 = (status?.EMPTY_APPROVEDHQ40 || 0) + (status?.EMPTY_AVHQ40 || 0) + (status?.EMPTY_ESTIMATEDHQ40 || 0) + (status?.EMPTY_REPAIREDHQ40 || 0) + (status?.EMPTY_UNESTIMATEDHQ40 || 0);

        
          return (
            <>
            {EMPTYHD20 > 0 | EMPTYHD40 > 0 | EMPTYHQ40 > 0?
              <>
                {
                  EMPTYHD20 > 0 && (
                  <><span>20HD x {EMPTYHD20}</span><br />
                  </>
                  )
                }

                {
                  EMPTYHD40 > 0 && (
                  <><span>40HD x {EMPTYHD40}</span><br /></>
                  )
                }

                {
                  EMPTYHQ40 > 0 && (
                  <><span>40HQ x {EMPTYHQ40}</span><br /></>
                  )
                }
              </>
            :
              "-"
            }
            </>
          );
        }
      },
      {
        name: 'Booked',
        center: true,
        selector: row => 
          <>
          {row.summary?.status?.BOOKEDHD20 > 0 | row.summary?.status?.BOOKEDHD40 > 0 | row.summary?.status?.BOOKEDHQ40 > 0?
            <>
            {row.summary?.status?.BOOKEDHD20 > 0 ? <><span>20HD x {row.summary?.status?.BOOKEDHD20}</span><br></br></>:""}
            {row.summary?.status?.BOOKEDHD40 > 0 ? <><span>40HD x {row.summary?.status?.BOOKEDHD40}</span><br></br></>:""}
            {row.summary?.status?.BOOKEDHQ40 > 0 ? <><span>40HQ x {row.summary?.status?.BOOKEDHQ40}</span><br></br></>:""}
            </>
          :"-"}
          </>,
        sortable: true,
      },
      {
        name: 'Picked',
        center: true,
        selector: row => 
          <>
          {row.summary?.status?.PICKEDHD20 > 0 | row.summary?.status?.PICKEDHD40 > 0 | row.summary?.status?.PICKEDHQ40 > 0?
            <>
            {row.summary?.status?.PICKEDHD20 > 0 ? <><span>20HD x {row.summary?.status?.PICKEDHD20}</span><br></br></>:""}
            {row.summary?.status?.PICKEDHD40 > 0 ? <><span>40HD x {row.summary?.status?.PICKEDHD40}</span><br></br></>:""}
            {row.summary?.status?.PICKEDHQ40 > 0 ? <><span>40HQ x {row.summary?.status?.PICKEDHQ40}</span><br></br></>:""}
            </>
          :"-"}
          </>,
        sortable: true,
      },
      {
        name: 'On the way',
        center: true,
        selector: row =>
          <>
          {row.summary?.status?.ON_THE_WAYHD20 > 0 | row.summary?.status?.ON_THE_WAYHD40 > 0 | row.summary?.status?.ON_THE_WAYHQ40 > 0?
            <>
            {row.summary?.status?.ON_THE_WAYHD20 > 0 ? <><span>20HD x {row.summary?.status?.ON_THE_WAYHD20}</span><br></br></>:""}
            {row.summary?.status?.ON_THE_WAYHD40 > 0 ? <><span>40HD x {row.summary?.status?.ON_THE_WAYHD40}</span><br></br></>:""}
            {row.summary?.status?.ON_THE_WAYHQ40 > 0 ? <><span>40HQ x {row.summary?.status?.ON_THE_WAYHQ40}</span><br></br></>:""}
            </>
          :"-"}
          </>,
        sortable: true,
      },
      {
        name: 'Import Laden',
        center: true,
        selector: row => 
          <>
          {row.summary?.status?.IMPORT_LADENHD20 > 0 | row.summary?.status?.IMPORT_LADENHD40 > 0 | row.summary?.status?.IMPORT_LADENHQ40 > 0?
            <>
            {row.summary?.status?.IMPORT_LADENHD20 > 0 ? <><span>20HD x {row.summary?.status?.IMPORT_LADENHD20}</span><br></br></>:""}
            {row.summary?.status?.IMPORT_LADENHD40 > 0 ? <><span>40HD x {row.summary?.status?.IMPORT_LADENHD40}</span><br></br></>:""}
            {row.summary?.status?.IMPORT_LADENHQ40 > 0 ? <><span>40HQ x {row.summary?.status?.IMPORT_LADENHQ40}</span><br></br></>:""}
            </>
          :"-"}
          </>,
        sortable: true,
      },
      {
        name: 'Exported',
        center: true,
        selector: row => 
          <>
          {row.summary?.status?.EXPORTEDHD20 > 0 | row.summary?.status?.EXPORTEDHD40 > 0 | row.summary?.status?.EXPORTEDHQ40 > 0?
            <>
            {row.summary?.status?.EXPORTEDHD20 > 0 ? <><span>20HD x {row.summary?.status?.EXPORTEDHD20}</span><br></br></>:""}
            {row.summary?.status?.EXPORTEDHD40 > 0 ? <><span>40HD x {row.summary?.status?.EXPORTEDHD40}</span><br></br></>:""}
            {row.summary?.status?.EXPORTEDHQ40 > 0 ? <><span>40HQ x {row.summary?.status?.EXPORTEDHQ40}</span><br></br></>:""}
            </>
          :"-"}
          </>,
        sortable: true,
      },
      {
        name: 'Leased Out',
        center: true,
        selector: row => 
          <>
          {row.summary?.status?.LEASED_OUTHD20 > 0 | row.summary?.status?.LEASED_OUTHD40 > 0 | row.summary?.status?.LEASED_OUTHQ40 > 0?
            <>
            {row.summary?.status?.LEASED_OUTHD20 > 0 ? <><span>20HD x {row.summary?.status?.LEASED_OUTHD20}</span><br></br></>:""}
            {row.summary?.status?.LEASED_OUTHD40 > 0 ? <><span>40HD x {row.summary?.status?.LEASED_OUTHD40}</span><br></br></>:""}
            {row.summary?.status?.LEASED_OUTHQ40 > 0 ? <><span>40HQ x {row.summary?.status?.LEASED_OUTHQ40}</span><br></br></>:""}
            </>
          :"-"}
          </>,
        sortable: true,
      },
      {
        name: 'Off Hired',
        center: true,
        selector: row => 
          <>
          {row.summary?.status?.OFFHIREDHD20 > 0 | row.summary?.status?.OFFHIREDHD40 > 0 | row.summary?.status?.OFFHIREDHQ40 > 0?
            <>
            {row.summary?.status?.OFFHIREDHD20 > 0 ? <><span>20HD x {row.summary?.status?.OFFHIREDHD20}</span><br></br></>:""}
            {row.summary?.status?.OFFHIREDHD40 > 0 ? <><span>40HD x {row.summary?.status?.OFFHIREDHD40}</span><br></br></>:""}
            {row.summary?.status?.OFFHIREDHQ40 > 0 ? <><span>40HQ x {row.summary?.status?.OFFHIREDHQ40}</span><br></br></>:""}
            </>
          :"-"}
          </>,
        sortable: true,
      },
      {
        name: 'Sold',
        center: true,
        selector: row => 
          <>
          {row.summary?.status?.SOLD_UNITHD20 > 0 | row.summary?.status?.SOLD_UNITHD40 > 0 | row.summary?.status?.SOLD_UNITHQ40 > 0?
            <>
            {row.summary?.status?.SOLD_UNITHD20 > 0 ? <><span>20HD x {row.summary?.status?.SOLD_UNITHD20}</span><br></br></>:""}
            {row.summary?.status?.SOLD_UNITHD40 > 0 ? <><span>40HD x {row.summary?.status?.SOLD_UNITHD40}</span><br></br></>:""}
            {row.summary?.status?.SOLD_UNITHQ40 > 0 ? <><span>40HQ x {row.summary?.status?.SOLD_UNITHQ40}</span><br></br></>:""}
            </>
          :"-"}
          </>,
        sortable: true,
      },
      {
        name: 'Unavailable',
        center: true,
        selector: row => 
          <>
          {row.summary?.status?.UNAVAILABLEHD20 > 0 | row.summary?.status?.UNAVAILABLEHD20 > 0 | row.summary?.status?.UNAVAILABLEHD20 > 0?
            <>
            {row.summary?.status?.UNAVAILABLEHD20 > 0 ? <><span>20HD x {row.summary?.status?.UNAVAILABLEHD20}</span><br></br></>:""}
            {row.summary?.status?.UNAVAILABLEHD40 > 0 ? <><span>40HD x {row.summary?.status?.UNAVAILABLEHD40}</span><br></br></>:""}
            {row.summary?.status?.UNAVAILABLEHQ40 > 0 ? <><span>40HQ x {row.summary?.status?.UNAVAILABLEHQ40}</span><br></br></>:""}
            </>
          :"-"}
          </>,
        sortable: true,
      },
      {
        name: 'None',
        center: true,
        selector: row =>
          <>
          {row.summary?.status?.NONEHD20 > 0 | row.summary?.status?.NONEHD40 > 0 | row.summary?.status?.NONEHQ40 > 0?
            <>
            {row.summary?.status?.NONEHD20 > 0 ? <><span>20HD x {row.summary?.status?.NONEHD20}</span><br></br></>:""}
            {row.summary?.status?.NONEHD40 > 0 ? <><span>40HD x {row.summary?.status?.NONEHD40}</span><br></br></>:""}
            {row.summary?.status?.NONEHQ40 > 0 ? <><span>40HQ x {row.summary?.status?.NONEHQ40}</span><br></br></>:""}
            </>
          :"-"}
          </>,
        sortable: true,
      },
      {
        name: 'Total',
        center: true,
        selector: row => 
        {
          const status = row.summary?.status || {};
          return (
            (status.BOOKED || 0) +
            (status.EMPTY_APPROVED || 0) +
            (status.EMPTY_AV || 0) +
            (status.EMPTY_ESTIMATED || 0) +
            (status.EMPTY_REPAIRED || 0) +
            (status.EMPTY_UNESTIMATED || 0) +
            (status.EXPORTED || 0) +
            (status.IMPORT_LADEN || 0) +
            (status.LEASED_OUT || 0) +
            (status.OFFHIRED || 0) +
            (status.ON_THE_WAY || 0) +
            (status.PICKED || 0) +
            (status.SOLD_UNIT || 0) +
            (status.UNAVAILABLE || 0) +
            (status.NONE || 0)
          );
        },
        sortable: true,
      }
    ];

    return (
      <div className="col-12 text-left" style={{ marginTop: -10, paddingLeft: 48, paddingRight: 0, zIndex: 100 }}>
        <DataTable
          columns={summarydetailcolumns}
          data={data?.dept_summary}
          progressPending={dataPending}
          progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
          noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
          highlightOnHover
          fixedHeader
          customStyles={containerSummaryDetailTableCustomStyles}
          dense
          selectableRows
        />
      </div>
    )
  };

  const exportToExcel = (data_to_export) => {
    const wb = XLSX.utils.book_new();

    const wsData = [];

    // Header row
    const header = [
      "Location", "Depot", "Agent", "Empty", "Booked", "Picked", "On the way",
      "Import Landed", "Exported", "Leased Out", "Off Hired", "Sold", "Unavailable", "None", "Total"
    ];
    wsData.push(header);

    let rowIndex = 1;

    const container_data = data_to_export === "All" ? data : data_to_export === "Filtered" ? filteredData : selectedRowData;

    container_data.forEach(loc => {
      // Summary Row
      wsData.push([
        loc.location, '', '', ...loc.dept_summary
      ]);
      rowIndex++;

      loc.dept_summary?.forEach(detail => {
        wsData.push([
          '', 
          `${detail?.summary?.depot}`,
          `${detail?.summary?.agent}`,

          `${
            (detail?.summary?.status?.EMPTY_AVHD20 !== undefined ? parseInt(detail.summary.status.EMPTY_AVHD20) : 0) +
            (detail?.summary?.status?.EMPTY_AVHD40 !== undefined ? parseInt(detail.summary.status.EMPTY_AVHD40) : 0) +
            (detail?.summary?.status?.EMPTY_AVHQ40 !== undefined ? parseInt(detail.summary.status.EMPTY_AVHQ40) : 0) +

            (detail?.summary?.status?.EMPTY_APPROVEDHD20 !== undefined ? parseInt(detail.summary.status.EMPTY_APPROVEDHD20) : 0) +
            (detail?.summary?.status?.EMPTY_APPROVEDHD40 !== undefined ? parseInt(detail.summary.status.EMPTY_APPROVEDHD40) : 0) +
            (detail?.summary?.status?.EMPTY_APPROVEDHQ40 !== undefined ? parseInt(detail.summary.status.EMPTY_APPROVEDHQ40) : 0) +

            (detail?.summary?.status?.EMPTY_ESTIMATEDHD20 !== undefined ? parseInt(detail.summary.status.EMPTY_ESTIMATEDHD20) : 0) +
            (detail?.summary?.status?.EMPTY_ESTIMATEDHD40 !== undefined ? parseInt(detail.summary.status.EMPTY_ESTIMATEDHD40) : 0) +
            (detail?.summary?.status?.EMPTY_ESTIMATEDHQ40 !== undefined ? parseInt(detail.summary.status.EMPTY_ESTIMATEDHQ40) : 0) +

            (detail?.summary?.status?.EMPTY_REPAIREDHD20 !== undefined ? parseInt(detail.summary.status.EMPTY_REPAIREDHD20) : 0) +
            (detail?.summary?.status?.EMPTY_REPAIREDHD40 !== undefined ? parseInt(detail.summary.status.EMPTY_REPAIREDHD40) : 0) +
            (detail?.summary?.status?.EMPTY_REPAIREDHQ40 !== undefined ? parseInt(detail.summary.status.EMPTY_REPAIREDHQ40) : 0) +

            (detail?.summary?.status?.EMPTY_UNESTIMATEDHD20 !== undefined ? parseInt(detail.summary.status.EMPTY_UNESTIMATEDHD20) : 0) +
            (detail?.summary?.status?.EMPTY_UNESTIMATEDHD40 !== undefined ? parseInt(detail.summary.status.EMPTY_UNESTIMATEDHD40) : 0) +
            (detail?.summary?.status?.EMPTY_UNESTIMATEDHQ40 !== undefined ? parseInt(detail.summary.status.EMPTY_UNESTIMATEDHQ40) : 0)
          }`,

          `${
            (detail?.summary?.status?.BOOKEDHD20 !== undefined ? parseInt(detail.summary.status.BOOKEDHD20) : 0) +
            (detail?.summary?.status?.BOOKEDHD40 !== undefined ? parseInt(detail.summary.status.BOOKEDHD40) : 0) +
            (detail?.summary?.status?.BOOKEDHQ40 !== undefined ? parseInt(detail.summary.status.BOOKEDHQ40) : 0)
          }`,

          `${
            (detail?.summary?.status?.PICKEDHD20 !== undefined ? parseInt(detail.summary.status.PICKEDHD20) : 0) +
            (detail?.summary?.status?.PICKEDHD40 !== undefined ? parseInt(detail.summary.status.PICKEDHD40) : 0) +
            (detail?.summary?.status?.PICKEDHQ40 !== undefined ? parseInt(detail.summary.status.PICKEDHQ40) : 0)
          }`,

          `${
            (detail?.summary?.status?.ON_THE_WAYHD20 !== undefined ? parseInt(detail.summary.status.ON_THE_WAYHD20) : 0) +
            (detail?.summary?.status?.ON_THE_WAYHD40 !== undefined ? parseInt(detail.summary.status.ON_THE_WAYHD40) : 0) +
            (detail?.summary?.status?.ON_THE_WAYHQ40 !== undefined ? parseInt(detail.summary.status.ON_THE_WAYHQ40) : 0)
          }`,

          `${
            (detail?.summary?.status?.IMPORT_LADENHD20 !== undefined ? parseInt(detail.summary.status.IMPORT_LADENHD20) : 0) +
            (detail?.summary?.status?.IMPORT_LADENHD40 !== undefined ? parseInt(detail.summary.status.IMPORT_LADENHD40) : 0) +
            (detail?.summary?.status?.IMPORT_LADENHQ40 !== undefined ? parseInt(detail.summary.status.IMPORT_LADENHQ40) : 0)
          }`,

          `${
            (detail?.summary?.status?.EXPORTEDHD20 !== undefined ? parseInt(detail.summary.status.EXPORTEDHD20) : 0) +
            (detail?.summary?.status?.EXPORTEDHD40 !== undefined ? parseInt(detail.summary.status.EXPORTEDHD40) : 0) +
            (detail?.summary?.status?.EXPORTEDHQ40 !== undefined ? parseInt(detail.summary.status.EXPORTEDHQ40) : 0)
          }`,

          `${
            (detail?.summary?.status?.LEASED_OUTHD20 !== undefined ? parseInt(detail.summary.status.LEASED_OUTHD20) : 0) +
            (detail?.summary?.status?.LEASED_OUTHD40 !== undefined ? parseInt(detail.summary.status.LEASED_OUTHD40) : 0) +
            (detail?.summary?.status?.LEASED_OUTHQ40 !== undefined ? parseInt(detail.summary.status.LEASED_OUTHQ40) : 0)
          }`,

          `${
            (detail?.summary?.status?.OFFHIREDHD20 !== undefined ? parseInt(detail.summary.status.OFFHIREDHD20) : 0) +
            (detail?.summary?.status?.OFFHIREDHD40 !== undefined ? parseInt(detail.summary.status.OFFHIREDHD40) : 0) +
            (detail?.summary?.status?.OFFHIREDHQ40 !== undefined ? parseInt(detail.summary.status.OFFHIREDHQ40) : 0)
          }`,

          `${
            (detail?.summary?.status?.SOLD_UNITHD20 !== undefined ? parseInt(detail.summary.status.SOLD_UNITHD20) : 0) +
            (detail?.summary?.status?.SOLD_UNITHD40 !== undefined ? parseInt(detail.summary.status.SOLD_UNITHD40) : 0) +
            (detail?.summary?.status?.SOLD_UNITHQ40 !== undefined ? parseInt(detail.summary.status.SOLD_UNITHQ40) : 0)
          }`,

          `${
            (detail?.summary?.status?.UNAVAILABLEHD20 !== undefined ? parseInt(detail.summary.status.UNAVAILABLEHD20) : 0) +
            (detail?.summary?.status?.UNAVAILABLEHD40 !== undefined ? parseInt(detail.summary.status.UNAVAILABLEHD40) : 0) +
            (detail?.summary?.status?.UNAVAILABLEHQ40 !== undefined ? parseInt(detail.summary.status.UNAVAILABLEHQ40) : 0)
          }`,

          `${
            (detail?.summary?.status?.NONEHD20 !== undefined ? parseInt(detail.summary.status.NONEHD20) : 0) +
            (detail?.summary?.status?.NONEHD40 !== undefined ? parseInt(detail.summary.status.NONEHD40) : 0) +
            (detail?.summary?.status?.NONEHQ40 !== undefined ? parseInt(detail.summary.status.NONEHQ40) : 0)
          }`,

          `${
            (detail?.summary?.status?.EMPTY_AVHD20 !== undefined ? parseInt(detail.summary.status.EMPTY_AVHD20) : 0) +
            (detail?.summary?.status?.EMPTY_AVHD40 !== undefined ? parseInt(detail.summary.status.EMPTY_AVHD40) : 0) +
            (detail?.summary?.status?.EMPTY_AVHQ40 !== undefined ? parseInt(detail.summary.status.EMPTY_AVHQ40) : 0) +
            (detail?.summary?.status?.EMPTY_APPROVEDHD20 !== undefined ? parseInt(detail.summary.status.EMPTY_APPROVEDHD20) : 0) +
            (detail?.summary?.status?.EMPTY_APPROVEDHD40 !== undefined ? parseInt(detail.summary.status.EMPTY_APPROVEDHD40) : 0) +
            (detail?.summary?.status?.EMPTY_APPROVEDHQ40 !== undefined ? parseInt(detail.summary.status.EMPTY_APPROVEDHQ40) : 0) +
            (detail?.summary?.status?.EMPTY_ESTIMATEDHD20 !== undefined ? parseInt(detail.summary.status.EMPTY_ESTIMATEDHD20) : 0) +
            (detail?.summary?.status?.EMPTY_ESTIMATEDHD40 !== undefined ? parseInt(detail.summary.status.EMPTY_ESTIMATEDHD40) : 0) +
            (detail?.summary?.status?.EMPTY_ESTIMATEDHQ40 !== undefined ? parseInt(detail.summary.status.EMPTY_ESTIMATEDHQ40) : 0) +
            (detail?.summary?.status?.EMPTY_REPAIREDHD20 !== undefined ? parseInt(detail.summary.status.EMPTY_REPAIREDHD20) : 0) +
            (detail?.summary?.status?.EMPTY_REPAIREDHD40 !== undefined ? parseInt(detail.summary.status.EMPTY_REPAIREDHD40) : 0) +
            (detail?.summary?.status?.EMPTY_REPAIREDHQ40 !== undefined ? parseInt(detail.summary.status.EMPTY_REPAIREDHQ40) : 0) +
            (detail?.summary?.status?.EMPTY_UNESTIMATEDHD20 !== undefined ? parseInt(detail.summary.status.EMPTY_UNESTIMATEDHD20) : 0) +
            (detail?.summary?.status?.EMPTY_UNESTIMATEDHD40 !== undefined ? parseInt(detail.summary.status.EMPTY_UNESTIMATEDHD40) : 0) +
            (detail?.summary?.status?.EMPTY_UNESTIMATEDHQ40 !== undefined ? parseInt(detail.summary.status.EMPTY_UNESTIMATEDHQ40) : 0) + 
            (detail?.summary?.status?.BOOKEDHD20 !== undefined ? parseInt(detail.summary.status.BOOKEDHD20) : 0) +
            (detail?.summary?.status?.BOOKEDHD40 !== undefined ? parseInt(detail.summary.status.BOOKEDHD40) : 0) +
            (detail?.summary?.status?.BOOKEDHQ40 !== undefined ? parseInt(detail.summary.status.BOOKEDHQ40) : 0) +
            (detail?.summary?.status?.PICKEDHD20 !== undefined ? parseInt(detail.summary.status.PICKEDHD20) : 0) +
            (detail?.summary?.status?.PICKEDHD40 !== undefined ? parseInt(detail.summary.status.PICKEDHD40) : 0) +
            (detail?.summary?.status?.PICKEDHQ40 !== undefined ? parseInt(detail.summary.status.PICKEDHQ40) : 0) +
            (detail?.summary?.status?.ON_THE_WAYHD20 !== undefined ? parseInt(detail.summary.status.ON_THE_WAYHD20) : 0) +
            (detail?.summary?.status?.ON_THE_WAYHD40 !== undefined ? parseInt(detail.summary.status.ON_THE_WAYHD40) : 0) +
            (detail?.summary?.status?.ON_THE_WAYHQ40 !== undefined ? parseInt(detail.summary.status.ON_THE_WAYHQ40) : 0) +
            (detail?.summary?.status?.IMPORT_LADENHD20 !== undefined ? parseInt(detail.summary.status.IMPORT_LADENHD20) : 0) +
            (detail?.summary?.status?.IMPORT_LADENHD40 !== undefined ? parseInt(detail.summary.status.IMPORT_LADENHD40) : 0) +
            (detail?.summary?.status?.IMPORT_LADENHQ40 !== undefined ? parseInt(detail.summary.status.IMPORT_LADENHQ40) : 0) +
            (detail?.summary?.status?.EXPORTEDHD20 !== undefined ? parseInt(detail.summary.status.EXPORTEDHD20) : 0) +
            (detail?.summary?.status?.EXPORTEDHD40 !== undefined ? parseInt(detail.summary.status.EXPORTEDHD40) : 0) +
            (detail?.summary?.status?.EXPORTEDHQ40 !== undefined ? parseInt(detail.summary.status.EXPORTEDHQ40) : 0) +
            (detail?.summary?.status?.LEASED_OUTHD20 !== undefined ? parseInt(detail.summary.status.LEASED_OUTHD20) : 0) +
            (detail?.summary?.status?.LEASED_OUTHD40 !== undefined ? parseInt(detail.summary.status.LEASED_OUTHD40) : 0) +
            (detail?.summary?.status?.LEASED_OUTHQ40 !== undefined ? parseInt(detail.summary.status.LEASED_OUTHQ40) : 0) +
            (detail?.summary?.status?.OFFHIREDHD20 !== undefined ? parseInt(detail.summary.status.OFFHIREDHD20) : 0) +
            (detail?.summary?.status?.OFFHIREDHD40 !== undefined ? parseInt(detail.summary.status.OFFHIREDHD40) : 0) +
            (detail?.summary?.status?.OFFHIREDHQ40 !== undefined ? parseInt(detail.summary.status.OFFHIREDHQ40) : 0) +
            (detail?.summary?.status?.SOLD_UNITHD20 !== undefined ? parseInt(detail.summary.status.SOLD_UNITHD20) : 0) +
            (detail?.summary?.status?.SOLD_UNITHD40 !== undefined ? parseInt(detail.summary.status.SOLD_UNITHD40) : 0) +
            (detail?.summary?.status?.SOLD_UNITHQ40 !== undefined ? parseInt(detail.summary.status.SOLD_UNITHQ40) : 0) + 
            (detail?.summary?.status?.UNAVAILABLEHD20 !== undefined ? parseInt(detail.summary.status.UNAVAILABLEHD20) : 0) +
            (detail?.summary?.status?.UNAVAILABLEHD40 !== undefined ? parseInt(detail.summary.status.UNAVAILABLEHD40) : 0) +
            (detail?.summary?.status?.UNAVAILABLEHQ40 !== undefined ? parseInt(detail.summary.status.UNAVAILABLEHQ40) : 0) +
            (detail?.summary?.status?.NONEHD20 !== undefined ? parseInt(detail.summary.status.NONEHD20) : 0) +
            (detail?.summary?.status?.NONEHD40 !== undefined ? parseInt(detail.summary.status.NONEHD40) : 0) +
            (detail?.summary?.status?.NONEHQ40 !== undefined ? parseInt(detail.summary.status.NONEHQ40) : 0)
          }`,
        ]);
        rowIndex++;
      });

      rowIndex++;
    });

    // Convert to worksheet
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Style: Bold header row
    for (let col = 0; col < header.length; col++) {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: col });
      if (!ws[cellRef]) continue;
      ws[cellRef].s = {
        font: { bold: true },
        alignment: { horizontal: 'center' }
      };
    }

    // Merge location cells vertically
    let currentRow = 1;
    container_data.forEach(loc => {
      const mergeEnd = currentRow + loc.dept_summary?.length;
      if (loc.dept_summary?.length > 0) {
        ws["!merges"] = ws["!merges"] || [];
        ws["!merges"].push({
          s: { r: currentRow, c: 0 },
          e: { r: mergeEnd - 1, c: 0 }
        });
      }
      currentRow = mergeEnd + 1; // +1 for spacer
    });

    // Append to workbook and download
    XLSX.utils.book_append_sheet(wb, ws, "Container Summary");
    XLSX.writeFile(wb, "container_summary_data.xlsx");
  }

  const exportToCSV = (data_to_export) => {
    const header = [
      "Location", "Depot", "Agent", "Empty", "Booked", "Picked", "On the way",
      "Import Landed", "Exported", "Leased Out", "Off Hired", "Sold", "Unavailable", "None", "Total"
    ];

    const rows = [];
    rows.push(header); // Add header row

    const container_data = data_to_export === "All" ? data : data_to_export === "Filtered" ? filteredData : selectedRowData;

    container_data.forEach(loc => {
      // rows.push([loc.location, '', '', ...loc.dept_summary]); // Summary placeholder
      rows.push([loc.location, '', '']); // Summary placeholder

      loc.dept_summary?.forEach(detail => {
        const s = detail?.summary?.status || {};

        rows.push([
          '', // Empty location cell
          detail?.summary?.depot || '',
          detail?.summary?.agent || '',

          (parseInt(s.EMPTY_AVHD20) || 0) + (parseInt(s.EMPTY_AVHD40) || 0) + (parseInt(s.EMPTY_AVHQ40) || 0) +
          (parseInt(s.EMPTY_APPROVEDHD20) || 0) + (parseInt(s.EMPTY_APPROVEDHD40) || 0) + (parseInt(s.EMPTY_APPROVEDHQ40) || 0) +
          (parseInt(s.EMPTY_ESTIMATEDHD20) || 0) + (parseInt(s.EMPTY_ESTIMATEDHD40) || 0) + (parseInt(s.EMPTY_ESTIMATEDHQ40) || 0) +
          (parseInt(s.EMPTY_REPAIREDHD20) || 0) + (parseInt(s.EMPTY_REPAIREDHD40) || 0) + (parseInt(s.EMPTY_REPAIREDHQ40) || 0) +
          (parseInt(s.EMPTY_UNESTIMATEDHD20) || 0) + (parseInt(s.EMPTY_UNESTIMATEDHD40) || 0) + (parseInt(s.EMPTY_UNESTIMATEDHQ40) || 0),

          (parseInt(s.BOOKEDHD20) || 0) + (parseInt(s.BOOKEDHD40) || 0) + (parseInt(s.BOOKEDHQ40) || 0),

          (parseInt(s.PICKEDHD20) || 0) + (parseInt(s.PICKEDHD40) || 0) + (parseInt(s.PICKEDHQ40) || 0),

          (parseInt(s.ON_THE_WAYHD20) || 0) + (parseInt(s.ON_THE_WAYHD40) || 0) + (parseInt(s.ON_THE_WAYHQ40) || 0),

          (parseInt(s.IMPORT_LADENHD20) || 0) + (parseInt(s.IMPORT_LADENHD40) || 0) + (parseInt(s.IMPORT_LADENHQ40) || 0),

          (parseInt(s.EXPORTEDHD20) || 0) + (parseInt(s.EXPORTEDHD40) || 0) + (parseInt(s.EXPORTEDHQ40) || 0),

          (parseInt(s.LEASED_OUTHD20) || 0) + (parseInt(s.LEASED_OUTHD40) || 0) + (parseInt(s.LEASED_OUTHQ40) || 0),

          (parseInt(s.OFFHIREDHD20) || 0) + (parseInt(s.OFFHIREDHD40) || 0) + (parseInt(s.OFFHIREDHQ40) || 0),

          (parseInt(s.SOLD_UNITHD20) || 0) + (parseInt(s.SOLD_UNITHD40) || 0) + (parseInt(s.SOLD_UNITHQ40) || 0),

          (parseInt(s.UNAVAILABLEHD20) || 0) + (parseInt(s.UNAVAILABLEHD40) || 0) + (parseInt(s.UNAVAILABLEHQ40) || 0),

          (parseInt(s.NONEHD20) || 0) + (parseInt(s.NONEHD40) || 0) + (parseInt(s.NONEHQ40) || 0),

          // Total
          (parseInt(s.EMPTY_AVHD20) || 0) + (parseInt(s.EMPTY_AVHD40) || 0) + (parseInt(s.EMPTY_AVHQ40) || 0) +
          (parseInt(s.EMPTY_APPROVEDHD20) || 0) + (parseInt(s.EMPTY_APPROVEDHD40) || 0) + (parseInt(s.EMPTY_APPROVEDHQ40) || 0) +
          (parseInt(s.EMPTY_ESTIMATEDHD20) || 0) + (parseInt(s.EMPTY_ESTIMATEDHD40) || 0) + (parseInt(s.EMPTY_ESTIMATEDHQ40) || 0) +
          (parseInt(s.EMPTY_REPAIREDHD20) || 0) + (parseInt(s.EMPTY_REPAIREDHD40) || 0) + (parseInt(s.EMPTY_REPAIREDHQ40) || 0) +
          (parseInt(s.EMPTY_UNESTIMATEDHD20) || 0) + (parseInt(s.EMPTY_UNESTIMATEDHD40) || 0) + (parseInt(s.EMPTY_UNESTIMATEDHQ40) || 0) +
          (parseInt(s.BOOKEDHD20) || 0) + (parseInt(s.BOOKEDHD40) || 0) + (parseInt(s.BOOKEDHQ40) || 0) +
          (parseInt(s.PICKEDHD20) || 0) + (parseInt(s.PICKEDHD40) || 0) + (parseInt(s.PICKEDHQ40) || 0) +
          (parseInt(s.ON_THE_WAYHD20) || 0) + (parseInt(s.ON_THE_WAYHD40) || 0) + (parseInt(s.ON_THE_WAYHQ40) || 0) +
          (parseInt(s.IMPORT_LADENHD20) || 0) + (parseInt(s.IMPORT_LADENHD40) || 0) + (parseInt(s.IMPORT_LADENHQ40) || 0) +
          (parseInt(s.EXPORTEDHD20) || 0) + (parseInt(s.EXPORTEDHD40) || 0) + (parseInt(s.EXPORTEDHQ40) || 0) +
          (parseInt(s.LEASED_OUTHD20) || 0) + (parseInt(s.LEASED_OUTHD40) || 0) + (parseInt(s.LEASED_OUTHQ40) || 0) +
          (parseInt(s.OFFHIREDHD20) || 0) + (parseInt(s.OFFHIREDHD40) || 0) + (parseInt(s.OFFHIREDHQ40) || 0) +
          (parseInt(s.SOLD_UNITHD20) || 0) + (parseInt(s.SOLD_UNITHD40) || 0) + (parseInt(s.SOLD_UNITHQ40) || 0) +
          (parseInt(s.UNAVAILABLEHD20) || 0) + (parseInt(s.UNAVAILABLEHD40) || 0) + (parseInt(s.UNAVAILABLEHQ40) || 0) +
          (parseInt(s.NONEHD20) || 0) + (parseInt(s.NONEHD40) || 0) + (parseInt(s.NONEHQ40) || 0)
        ]);
      });

      rows.push([]); // Empty row for separation
    });

    // Convert to CSV string
    const csvContent = rows.map(row => row.map(cell => `"${cell}"`).join(',')).join('\n');

    // Trigger download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "container_summary_data.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const exportToPDF = (data_to_export) => {
    const doc = new jsPDF('l', 'mm', 'a4'); // landscape, mm, A4 size
    const header = [
      "Location", "Depot", "Agent", "Empty", "Booked", "Picked", "On the way",
      "Import Landed", "Exported", "Leased Out", "Off Hired", "Sold", "Unavailable", "None", "Total"
    ];

    const pdfData = [];
    const container_data = data_to_export === "All" ? data : data_to_export === "Filtered" ? filteredData : selectedRowData;

    container_data.forEach(loc => {
      pdfData.push([loc.location, '', '', '', '', '', '', '', '', '', '', '', '', '', '']);

      loc.dept_summary?.forEach(detail => {
        const getTotalByKeys = (keys) =>
          keys.reduce(
            (sum, key) => sum + (detail?.summary?.status?.[key] !== undefined ? parseInt(detail.summary.status[key]) : 0),
            0
          );

        const empty = getTotalByKeys([
          "EMPTY_AVHD20", "EMPTY_AVHD40", "EMPTY_AVHQ40",
          "EMPTY_APPROVEDHD20", "EMPTY_APPROVEDHD40", "EMPTY_APPROVEDHQ40",
          "EMPTY_ESTIMATEDHD20", "EMPTY_ESTIMATEDHD40", "EMPTY_ESTIMATEDHQ40",
          "EMPTY_REPAIREDHD20", "EMPTY_REPAIREDHD40", "EMPTY_REPAIREDHQ40",
          "EMPTY_UNESTIMATEDHD20", "EMPTY_UNESTIMATEDHD40", "EMPTY_UNESTIMATEDHQ40"
        ]);

        const booked = getTotalByKeys(["BOOKEDHD20", "BOOKEDHD40", "BOOKEDHQ40"]);
        const picked = getTotalByKeys(["PICKEDHD20", "PICKEDHD40", "PICKEDHQ40"]);
        const on_the_way = getTotalByKeys(["ON_THE_WAYHD20", "ON_THE_WAYHD40", "ON_THE_WAYHQ40"]);
        const import_landed = getTotalByKeys(["IMPORT_LADENHD20", "IMPORT_LADENHD40", "IMPORT_LADENHQ40"]);
        const exported = getTotalByKeys(["EXPORTEDHD20", "EXPORTEDHD40", "EXPORTEDHQ40"]);
        const leased_out = getTotalByKeys(["LEASED_OUTHD20", "LEASED_OUTHD40", "LEASED_OUTHQ40"]);
        const off_hired = getTotalByKeys(["OFFHIREDHD20", "OFFHIREDHD40", "OFFHIREDHQ40"]);
        const sold = getTotalByKeys(["SOLD_UNITHD20", "SOLD_UNITHD40", "SOLD_UNITHQ40"]);
        const unavailable = getTotalByKeys(["UNAVAILABLEHD20", "UNAVAILABLEHD40", "UNAVAILABLEHQ40"]);
        const none = getTotalByKeys(["NONEHD20", "NONEHD40", "NONEHQ40"]);

        const total = empty + booked + picked + on_the_way + import_landed + exported + leased_out +
                      off_hired + sold + unavailable + none;

        pdfData.push([
          '', 
          `${detail?.summary?.depot}`,
          `${detail?.summary?.agent}`,
          `${empty}`,
          `${booked}`,
          `${picked}`,
          `${on_the_way}`,
          `${import_landed}`,
          `${exported}`,
          `${leased_out}`,
          `${off_hired}`,
          `${sold}`,
          `${unavailable}`,
          `${none}`,
          `${total}`
        ]);
      });

      // Empty row for spacing
      pdfData.push(['', '', '', '', '', '', '', '', '', '', '', '', '', '', '']);
    });

    autoTable(doc, {
      head: [header],
      body: pdfData,
      styles: { fontSize: 6 },
      headStyles: { fillColor: [18, 112, 140] },
      startY: 10,
      theme: 'grid',
    });

    doc.save("container_summary_data.pdf");
  };


  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar} />
      <SideNavbar sidebarCollapsed={menuDrawerShow} activeMenu="Inventory" activeSubMenu="ContainerSummary" activeSubMenuLevel1="" permissionFromTopNavbar={dataFromTopNavBar} />

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"} >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-sm-4 col-md-4 col-lg-6 py-1">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow ?
                  <span><i className="fa fa-chevron-left mx-1"></i></span> :
                  <span><i className="fa fa-chevron-right mx-1"></i></span>
                }
              </Button>
              <span className="page-header-text">Container Summary</span>
              {filteredData.length<1?
                <span className="text-inox-green mx-3 pointer" style={{ verticalAlign: 'middle' }} onClick={() => setFilters("","")}>
                  Clear Filters
                </span>
                :""
              }
            </div>

            <div className="col-sm-8 col-md-8 col-lg-6">
              <div className="row right" style={{ float: 'inline-end'}}>
                {/* <div className="col-3 px-1">
                  <div class="form-row">
                    <input className="form form-control form-control-sm my-1" placeholder="Location" onChange={e => handleFilterChange('location__name', e.target.value)}/>
                  </div>
                </div>

                <div className="col-3 px-1">
                  <div class="form-group">
                    <input className="form form-control form-control-sm my-1" onChange={e => handleFilterChange('owner__name', e.target.value)}/>
                  </div>
                </div>

                <div className="col-3" style={{ paddingLeft: 3 }}>
                  <div class="form-group">
                    <input className="form form-control form-control-sm my-1" onChange={e => handleFilterChange('owner__name', e.target.value)}/>
                  </div>
                </div> */}

                <div className="col-3">
                  <div class="row mt-1">
                    {/* <div className="col-4">
                      <button className="btn btn-sm btn-inox-green text-white" style={{ width: 60, float: 'right' }}>Search</button>
                    </div>
                    <div className="col-4" style={{ marginLeft: '5px' }}>
                      <button className="btn btn-sm btn-secondary mx-2" style={{ width: 60, float: 'right' }}>Clear</button>
                    </div> */}
                    <div className="col-1" style={{ marginLeft: '10px' }}>
                      <div class="dropdown">
                        <button type="button" style={{ paddingTop: 7, paddingBottom: 8, float: 'right' }} title="Language" class="btn btn-inox-green border-0 text-white" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="d-flex align-items-center">
                                <span className="fa fa-bars"></span>
                            </span>
                        </button>

                        <div class="dropdown-menu custom-topnavbar-dropdown-menu dropdown-menu-end">
                            <span class="dropdown-item pointer pointer" onClick={() => exportToCSV("All")}>
                              <span>
                                <i className="fa fa-file-text-o text-primary" style={{ marginRight : 10}}></i>Export All Data As CSV
                              </span>
                            </span>

                            <span class="dropdown-item pointer" onClick={() => {
                                if(filteredData.length > 0){
                                  exportToCSV("Filtered")
                                }
                                else{
                                  alert("Filter record to export")
                                }
                              }}>
                                <span>
                                  <i className="fa fa-file-text-o text-primary" style={{ marginRight : 10}}></i>Export Filtered Data As CSV
                                </span>
                            </span>

                            <span class={`dropdown-item pointer ${selectedRowData.length < 1?'disabled':''}`} 
                              onClick={() => {
                                if(selectedRowData.length > 0){
                                  exportToCSV("Selected")
                                }
                                else{
                                  alert("Select record to export")
                                }
                              }}>
                                <span>
                                  <i className="fa fa-file-text-o text-primary" style={{ marginRight : 10}}></i>Export Selected Data As CSV
                                </span>
                            </span>

                            <span class="dropdown-item pointer" onClick={() => exportToPDF("All")}>
                                <span>
                                  <i className="fa fa-file-pdf-o text-danger" style={{ marginRight : 10}}></i>Export All Data As PDF
                                </span>
                            </span>

                            <span class="dropdown-item pointer" onClick={() => {
                                if(filteredData.length > 0){
                                  exportToPDF("Filtered")
                                }
                                else{
                                  alert("Filter record to export")
                                }
                              }}>
                                <span>
                                  <i className="fa fa-file-pdf-o text-danger" style={{ marginRight : 10}}></i>Export Filtered Data As PDF
                                </span>
                            </span>

                            <span class={`dropdown-item pointer ${selectedRowData.length < 1?'disabled':''}`} 
                              onClick={() => {
                                if(selectedRowData.length > 0){
                                  exportToPDF("Selected")
                                }
                                else{
                                  alert("Select record to export")
                                }
                              }}>
                                <span>
                                  <i className="fa fa-file-pdf-o text-danger" style={{ marginRight : 10}}></i>Export Selected Data As PDF
                                </span>
                            </span>

                            <span class="dropdown-item pointer" onClick={() => exportToExcel("All")}>
                                <span>
                                  <i className="fa fa-file-excel-o text-success" style={{ marginRight : 10}}></i>Export All Data As Excel
                                </span>
                            </span>

                            <span class="dropdown-item pointer" onClick={() => {
                                if(filteredData.length > 0){
                                  exportToExcel("Filtered")
                                }
                                else{
                                  alert("Filter record to export")
                                }
                              }}>
                                <span>
                                  <i className="fa fa-file-excel-o text-success" style={{ marginRight : 10}}></i>Export Filtered Data As Excel
                                </span>
                            </span>

                            <span class={`dropdown-item pointer ${selectedRowData.length < 1?'disabled':''}`} 
                              onClick={() => {
                                if(selectedRowData.length > 0){
                                  exportToExcel("Selected")
                                }
                                else{
                                  alert("Select record to export")
                                }
                              }}>
                                <span>
                                  <i className="fa fa-file-excel-o text-success" style={{ marginRight : 10}}></i>Export Selected Data As Excel
                                </span>
                            </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 text-left" style={{ marginTop: -5, paddingLeft: 20, paddingRight: 30 }}>
          <DataTable
            columns={columns}
            data={filteredData}
            progressPending={dataPending}
            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
            noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 25, 50, 100, 1000, 5000, 10000]}
            highlightOnHover
            fixedHeader
            persistTableHead
            customStyles={userTableCustomStyles}
            dense

            expandableRows
            expandableRowsComponent={ExpandedComponent}
            expandableRowDisabled={row => row.location == 'Total'}

            selectableRows
            onSelectedRowsChange={(e) => setSelectedRowData(e.selectedRows)}
            selectableRowDisabled={row => row.location == 'Total'}

            conditionalRowStyles={[
              {
                when: row => row.location == 'Total',
                style: {
                  '& .bxyMst': {
                    visibility: 'hidden', // Hide the expand arrow
                  },
                  '& .cdoEeX': {
                    visibility: 'hidden', // Hide the expand arrow
                  },
                },
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}

export default ContainerSummary;
